const messages = {
    pages: {
        main: {
            sections: {
                title: 'Procesy produkcyjne',
                actions: {
                    add: 'Dodaj proces produkcyjny'
                },
                filters: {
                    searchPlaceholder: 'Nazwa...'
                },
                table: {
                    columns: {
                        name: 'Nazwa',
                        actions: 'Akcje'
                    }
                }
            },
            dialog: {
                titles: {
                    create: 'Tworzenie procesu produkcyjnego',
                    edit: 'Edycja procesu produkcyjnego {name}',
                    editPrefix: 'Edycja procesu produkcyjnego'
                },
                fields: {
                    name: 'Nazwa',
                    properties: 'Cechy produkcyjne:',
                    propertiesPlaceholder: 'Wybierz cechy produkcyjne',
                    noPropertiesFound: 'Nie znaleziono cech produkcyjnych',
                    productionCode: 'Kod produkcyjny'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę procesu produkcyjnego.',
                    productionCodeRequired: 'Proszę wybrać kod produkcyjny.'
                }
            },
            notifications: {
                saved: 'Proces produkcyjny został zapisany.'
            },
            errors: {
                fetchList: 'Pobranie listy procesów produkcyjnych nie powiodło się.',
                fetchOne: 'Pobranie procesu produkcyjnego nie powiodło się.',
                save: 'Zapisanie procesu produkcyjnego nie powiodło się.',
                fetchSteps: 'Pobranie kodów nie powiodło się.',
                fetchProperties: 'Pobranie cech produkcyjnych nie powiodło się.'
            }
        }
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
